var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.71919C0 0.77025 0.794438 0 1.77375 0H22.2262C23.2059 0 24 0.77025 24 1.71919V22.2811C24 23.2303 23.2059 24 22.2262 24H1.77375C0.794531 24 0 23.2304 0 22.2814V1.71891V1.71919Z",
    fill: "#523280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2933 20.0847V9.27985H3.70192V20.0847H7.29367H7.2933ZM5.49836 7.80488C6.75048 7.80488 7.53002 6.9752 7.53002 5.93832C7.50658 4.87782 6.75048 4.07129 5.52217 4.07129C4.29302 4.07129 3.49023 4.87782 3.49023 5.93823C3.49023 6.9751 4.26948 7.80479 5.47483 7.80479H5.49808L5.49836 7.80488ZM9.28117 20.0847H12.8723V14.0514C12.8723 13.7289 12.8957 13.4056 12.9906 13.1753C13.2501 12.5298 13.841 11.8616 14.8333 11.8616C16.1325 11.8616 16.6525 12.8524 16.6525 14.305V20.0847H20.2435V13.8895C20.2435 10.5709 18.472 9.02654 16.1093 9.02654C14.1721 9.02654 13.3213 10.1093 12.8486 10.8467H12.8725V9.28023H9.28136C9.32823 10.2939 9.28108 20.0851 9.28108 20.0851L9.28117 20.0847Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6a16db2c3673b6daa21db539479f1c1d.svg";
export { ForwardRef as ReactComponent };